import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import BasicInfoForm from '../../wizard/forms/BasicInfoForm';
import VerificationStepActionBar from '../VerificationStepActionBar';
import { VERIFICATION_STEPS } from '../../../types/verification';

const STEP = VERIFICATION_STEPS.BASIC_INFO;

const VerifyBasicInfoStep: React.FC = () => {
  const {
    state,
    stepErrors,
    updateBasicInfo,
    saveBasicInfo,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
  } = useVerificationWizard();

  const errors = stepErrors[STEP] || {};

  return (
    <div className="wizard-step">
      <h2>Verify Basic Information</h2>
      <p className="step-description">
        Review and update the clinic's basic information. Addresses are verified on the next step.
      </p>

      {/* showAddress={false} (SLV2-2821): addresses live on the Verify Addresses step —
          showing them here duplicated the fields AND silently dropped edits (this step's
          save reads addresses from mailingAddress state, not basicInfo). */}
      <BasicInfoForm
        values={state.basicInfo}
        onChange={updateBasicInfo}
        errors={errors}
        showAddress={false}
      />

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={saveBasicInfo}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyBasicInfoStep;
